var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 65,
    viewBox: "0 0 371 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.806 14L53.9031 42.2633L47.6777 55L28.4297 14H39.806Z",
    fill: "url(#paint0_linear_36_1604)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5739 14L58.3449 31.0299L57.2728 20.2254L48.7578 14H66.5739Z",
    fill: "#31F6A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.43 14.0024L34.5174 26.7367L20.4227 54.8743H9.04395L28.43 14.0024Z",
    fill: "#24B4D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M28.4298 14.0024L27.375 16.361L34.5172 26.7367L28.4298 14.0024Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.721 17.2669V51.3406H111.391L93.1009 28.8574V51.3406H84.7705V18.5828L93.1009 16.3896L111.391 38.8662V17.2669H119.721Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.618 43.91H160.499L158.303 51.3406H127.489V16.3896H160.499L158.303 23.8202H135.618V30.1737H156.76V37.6315H135.618V43.91Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.004 16.3896H202.762L187.94 33.6267L203.216 51.3406H193.458L181.864 37.7894L170.269 51.3406H160.498L175.774 33.6267L160.952 16.3896H170.723L181.864 29.4435L193.004 16.3896Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.216 16.3896H240.109L237.836 23.8202H224.644V51.3406H216.229V23.8202H203.216V16.3896Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.108 16.3896H249.001L255.748 42.3878L265.683 16.3896H270.837L280.771 42.3878L287.519 16.3896H296.418L284.966 50.9673L276.535 53.2823L268.256 30.3849L259.715 50.9673L251.278 53.2823L240.108 16.3896Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M308.018 39.8365H317.472L310.88 25.694L299.092 51.3406H290.594L306.667 18.5828L314.73 16.3896L331.37 51.3406H322.872L320.736 46.7749H305.058L308.018 39.8365Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M347.161 51.3406H338.753V39.2676L321.66 16.3896H331.418L343.012 32.7505L354.607 16.3896H364.378L347.175 39.4517L347.161 51.3406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_1604",
    x1: 28.4297,
    y1: 34.5,
    x2: 53.9031,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#31F6A9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.b5c36e0806989922f087190c09953705.svg";
export { ForwardRef as ReactComponent };